import { AssessmentOverviewFormField } from 'components/Assessments/SocAssessment/sections/AssessmentOverview/formField'
import { PatientOverviewFormField } from 'components/Assessments/SocAssessment/sections/PatientOverview/formField'
import { MedicalBackgroundFormField } from 'components/Assessments/SocAssessment/sections/MedicalBackground/formField'
import { MedicationsFormField } from 'components/Assessments/SocAssessment/sections/Medications/formField'
import { SkilledNeedsFormField } from 'components/Assessments/SocAssessment/sections/SkilledNeeds/formField'
import { ADLNeedsFormField } from 'components/Assessments/SocAssessment/sections/ADLNeeds/formField'
import { DischargePlanningFormField } from 'components/Assessments/SocAssessment/sections/DischargePlanning/formField'
import { AuthorizationFormField } from 'components/Assessments/SocAssessment/sections/Authorization/formField'
import { VisitSchedulingFormField } from 'components/Assessments/SocAssessment/sections/VisitScheduling/formField'
import { PlanOfCareFormField } from 'components/Assessments/SocAssessment/sections/PlanOfCare/formField'
import { SupervisoryReviewFormField } from 'components/Assessments/SocAssessment/sections/SupervisoryReview/formField'
import { NarrativeFormField } from 'components/Assessments/SocAssessment/sections/Narrative/formField'
import { FinalStepsFormField } from 'components/Assessments/SocAssessment/sections/FinalSteps/formField'

export const SocFormField = {
  ...AssessmentOverviewFormField,
  ...PatientOverviewFormField,
  ...MedicalBackgroundFormField,
  ...MedicationsFormField,
  ...SkilledNeedsFormField,
  ...ADLNeedsFormField,
  ...DischargePlanningFormField,
  ...AuthorizationFormField,
  ...VisitSchedulingFormField,
  ...PlanOfCareFormField,
  ...SupervisoryReviewFormField,
  ...NarrativeFormField,
  ...FinalStepsFormField
} as const

export type SocFormField = (typeof SocFormField)[keyof typeof SocFormField]
